import httpUtils from '../../utils/HttpUtils'

class VerifierService {

  //获取店铺列表信息
  async login(code = '') {
    let result = null;
    try {
      result = await httpUtils.get('/mall/shop/verifier/login', { code })
    } catch (error) {
      console.log('连接失败', error);
      result = { code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取店铺列表信息
  async getByUnionId(unionId, openid) {
    let result = null;
    try {
      result = await httpUtils.get('/mall/shop/verifier/getByUnionId', { unionId, openid })
    } catch (error) {
      console.log('连接失败', error);
      result = { code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取店铺列表信息
  async getShop(shopId) {
    let result = null;
    try {
      result = await httpUtils.get('/mall/shop/verifier/getShop', { shopId })
    } catch (error) {
      console.log('连接失败', error);
      result = { code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取店铺列表信息
  async register({ name, shopId, unionId, gzhOpenid }) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/shop/verifier/register', { name, shopId, unionId, gzhOpenid })
    } catch (error) {
      console.log('连接失败', error);
      result = { code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new VerifierService()
